/**
 * JSR
 * menu.js
 * Funkce pro hlavní menu (maska podmenu, mobilní menu, skrývání hlavičky při scrollu)
 *
 * @package zaklad
 *
 * @author Jiří Chalupný <jchalupny@skit.cz>
 * @copyright (c) 2007-2026 Josef Šmíd
 * @version 2.5.9
 */

document.addEventListener("DOMContentLoaded", function () {
    const menuItems = document.querySelectorAll(".titulek .head.submenu");
    const subMenus = document.querySelectorAll(".titulek .subcat");
    const divMask = document.querySelector("div.mask");

    function showMask() {
        if (window.innerWidth >= 992) {
            divMask.classList.add("show");
        }
    }

    function hideMaskIfNotOverSubmenu(event) {
        if (window.innerWidth >= 992) {
            if (
                !event.relatedTarget ||
                (!event.relatedTarget.closest(".subcat") &&
                    !event.relatedTarget.closest(".head.submenu"))
            ) {
                divMask.classList.remove("show");
            }
        }
    }
 
    menuItems.forEach(function (button) {
        button.addEventListener("mouseenter", showMask);
        button.addEventListener("mouseleave", hideMaskIfNotOverSubmenu);
    });

    subMenus.forEach(function (subMenu) {
        subMenu.addEventListener("mouseenter", showMask);
        subMenu.addEventListener("mouseleave", hideMaskIfNotOverSubmenu);
    });
});

document.addEventListener("DOMContentLoaded", function () {
    const menu = document.querySelector(".mobile-menu");
    const hamburger = document.querySelector(".hamburger");

    const menuItems = menu.querySelectorAll(".submenu > a .menu-arrow");

    menuItems.forEach(function (item) {
        item.addEventListener("click", function (event) {
            event.preventDefault();
            console.log(item);

            let submenu = item.closest(".submenu");

            if (submenu) {
                submenu.classList.toggle("is-active");
            }
        });
    });

    hamburger.addEventListener("click", function () {
        hamburger.classList.toggle("is-active");
        menu.classList.toggle("is-active");
    });
});

var prevScrollpos = null;//pozice se čte až při prvním scrollu, čtení při načtení stránky vynucuje přepočet layoutu
window.onscroll = function () {
    const header = document.querySelector("header");

    if (window.innerWidth >= 992) {
        const currentScrollPos = window.scrollY;
        if (prevScrollpos === null || prevScrollpos > currentScrollPos) {
            header.style.top = "0";
        } else {
            const headerHeight = header.offsetHeight;
            header.style.top = `-${headerHeight}px`;
        }
        prevScrollpos = currentScrollPos;
    } else {
        header.style.top = "0";
    }
};
